import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Routes, Route } from 'react-router-dom';

import Home from './components/pages/Home';
import TermsConditions from './components/pages/TermsConditions';
import Privacy from './components/pages/Privacy';
import FAQ from './components/pages/FAQ';

import NotFound from './components/common/NotFound';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faq" element={<FAQ />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </HelmetProvider>
  );
}

export default App;